import { render } from "./PreviewArticle.vue?vue&type=template&id=ad27685e&scoped=true"
import script from "./PreviewArticle.vue?vue&type=script&lang=js"
export * from "./PreviewArticle.vue?vue&type=script&lang=js"

import "./PreviewArticle.vue?vue&type=style&index=0&id=ad27685e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ad27685e"

export default script